import { Component, OnInit, Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { Perform } from '../../models/perform';
import { PerformService } from '../../services/perform.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MessageBoxCheckDialog } from '../message-box-check/message-box-check.component';
import { Constants } from '../constants';

@Component({
  selector: 'app-perform',
  templateUrl: './perform.component.html',
  styleUrls: ['./perform.component.css']
})
export class PerformComponent implements OnInit {
  publicating: boolean = false;
  @Input() PerformID;
  @Input() nameComponent;
  @Input() Performs;
  @Input() Job;
  @Input() perform;
  createPerform = true;
  performs: any;
  errorMessage: string;
  listQuestions: any = [];
  textQuestion: string = "";
  nameLink: string = "";
  urlLink: string = "";
  typeQuestion: number;
  descriptionQuestion: string;
  name_perform: string;

  constructor(public dialogRef: MdDialogRef<PerformComponent>, private dialog: MdDialog, private performService: PerformService) { }

  ngOnInit() {
    if (this.nameComponent === "Crear"){
      this.createPerform = true;
      this.perform = new Perform();
    } else {
      this.createPerform = false;
      this.listQuestions = this.perform.items;
      this.name_perform = this.perform.name;
    }
    console.log(this.PerformID);

    this.typeQuestion = 1;
  }

  getPerform(id){
    for (let i = 0; i < this.performs.length; i++){
      if (id === this.performs[i].id){
        this.perform = this.performs[i];
        this.name_perform = this.perform.name;
        this.perform.items.forEach(element => {
            this.listQuestions.push(element);
        });
      }
    }
  }

  onPerformCheck(){
    if (this.createPerform) {
      this.onPostPerform();
    } else {
      this.onPutPerform();
    }
  }

  onPerform(){
    const dialogRef = this.dialog.open(MessageBoxCheckDialog);
    dialogRef.componentInstance.checkingData = true;
    dialogRef.componentInstance.message = 'Revise antes de continuar.';
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.onPerformCheck();
      }
    });
  }

  onPutPerform() {
    this.publicating = true;
    const id = this.perform.id;

    this.performService.putPerform(this.perform)
      .subscribe(
        data => {
          this.performs = data;
          this.publicating = false;
          this.dialogRef.close(data);
        },
        error => {
          console.log(error);
          this.errorMessage = <any>error;
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: error.json().name, alert: true, showIcon: true}});
        }
      );
  }

  onPostPerform() {
    this.addQuestion();
    this.addLink();
    this.perform.job_id = this.Job.id;
    this.perform.name = this.name_perform;
    this.perform.status = 1;
    this.perform.items = this.listQuestions;
    this.publicating = true;
    this.performService.postPerform(this.perform)
      .subscribe(
        data => {
          this.performs = data;
          this.publicating = false;
          this.dialogRef.close(data);
        },
        error => {
          console.log(error);
          this.errorMessage = <any>error;
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: error.message, alert: true, showIcon: true}});
        }
      );
  }

  getTypeName(id) {
    if (id == "1") {
      return "Selección Simple (S/N)";
    } else if (id == "2") {
      return "Texto (Máx 140 caractéres)";
    } else if (id == "3") {
      return "Selección Simple (A,B,C,D)";
    } else if (id == "4") {
      return "Selección Multiple (A,B,C,D)";
    } else {
      return "Desconocido";
    }
  }

  addQuestion() {
    if (!this.textQuestion || !this.typeQuestion) {
      return;
    }

    if (!this.descriptionQuestion) {
      this.descriptionQuestion = '';
    }

    this.listQuestions.push({
      name: this.textQuestion,
      // type: this.typeQuestion,
      description: this.descriptionQuestion,
    });

    this.textQuestion = "";
    this.typeQuestion = 1;
    this.descriptionQuestion = '';
  }

  addLink() {
    if (!this.nameLink || !this.urlLink) {
      return;
    }

    this.listQuestions.push({
      name: this.nameLink,
      // type: 3,
      // url: this.urlLink,
      description: '',
    });
  }

  removeQuestion(elm) {
    let index = -1;

    for (let _i = 0; _i < this.listQuestions.length; _i++) {
      if (this.listQuestions[_i].name == elm) {
        index = _i;
        break;
      }
    }

    if (index > -1) {
      this.listQuestions.splice(index, 1);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/perform/perform.component.ts